import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../bmr/services/api/axios.config";
import { notify } from "../../../bmr/utils/methods/notification";

const initialState = {
  isLoading: false,
  data: [],
  inputTypes: [],
  options: {},
  validationOptions: [],
  getValidationData: [],
  formulaVariables: [],
  conditions: [],
  linkedField: null,
  getDependentField: null,
  manualConditions: [],
};

// Fetch all the sections
export const fetchInputTypes = createAsyncThunk(
  "bmr/fetchInputTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/ftb/input-types`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Add Linked Field.
export const addLinkedField = createAsyncThunk(
  "bmr/addLinkedField",
  async ({ fieldId, data }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/ftb/linked-field/add/${fieldId}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
// Add Linked Field.
// export const addDependencyField = createAsyncThunk(
//   "bmr/addDependencyField",
//   async ({ fieldId, data }, { rejectWithValue }) => {
//     try {
//       const response = await api.post(`/ftb/time-comparison/add/${fieldId}`, data);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response ? error.response.data : error.message
//       );
//     }
//   }
// );

export const addDependencyField = createAsyncThunk(
  "bmr/addDependencyField",
  async ({ fieldId, data, routeType }, { rejectWithValue }) => {
    try {
      const routeMap = {
        time: "time-comparison",
        date: "date-comparison",
        datetime: "datetime-comparison",
      };

      const route = routeMap[routeType];
      const response = await api.post(
        `/ftb/${route}/add/${fieldId}`,
        data
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// fetch added dependency field
// export const getAddDependencyField = createAsyncThunk(
//   "bmr/getAddDependencyField",
//   async ({ fieldId }, { rejectWithValue }) => {
//     if (!fieldId) {
//       return rejectWithValue("fieldId is required");
//     }
//     try {
//       const response = await api.get(`/ftb/time-comparison/${fieldId}`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response ? error.response.data : error.message
//       );
//     }
//   }
// );


//@info handling the dependency field with different route type
export const getAddDependencyField = createAsyncThunk(
  "bmr/getAddDependencyField",
  async ({ fieldId, routeType }, { rejectWithValue }) => {
    if (!fieldId) {
      return rejectWithValue("fieldId is required");
    }

    try {
      const routeMap = {
        time: "time-comparison",
        date: "date-comparison",
        datetime: "datetime-comparison",
      };

      const route = routeMap[routeType];

      const response = await api.get(
        `/ftb/${route}/${fieldId}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


//@info handle the delete dependency
// delete the formula variables in calculation fields
export const deleteDependency = createAsyncThunk(
  "bmr/deleteDependency",
  async ({ fieldId, routeType }, { rejectWithValue }) => {
     if (!fieldId) {
      return rejectWithValue("fieldId is required");
    }
    try {
      const routeMap = {
        time: "time-comparison",
        date: "date-comparison",
        datetime: "datetime-comparison",
      };
      const route = routeMap[routeType];
      const response = await api.delete(
        `/ftb/${route}/delete/${fieldId}`
      );
         return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


// fetch linked field
export const getLinkedField = createAsyncThunk(
  "bmr/getLinkedField",
  async ({ fieldId }, { rejectWithValue }) => {
    if (!fieldId) {
      return rejectWithValue("fieldId is required");
    }
    try {
      const response = await api.get(`/ftb/linked-field/get/${fieldId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Add formula variable in calculation field.
export const addFormulaVariables = createAsyncThunk(
  "bmr/addFormulaVariables",
  async ({ fieldId, data }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/ftb/calculation/add/${fieldId}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error || error.response || error.response.data || error.message
      );
    }
  }
);

// fetch the formula variables for calculation fields
export const getFormulaVariables = createAsyncThunk(
  "bmr/getFormulaVariables",
  async ({ fieldId }, { rejectWithValue }) => {
    if (!fieldId) {
      return rejectWithValue("fieldId is required");
    }
    try {
      const response = await api.get(`/ftb/calculation/get/${fieldId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// delete the formula variables in calculation fields
export const deleteFormulaVariables = createAsyncThunk(
  "bmr/deleteFormulaVariables",
  async ({ fieldId, variableIds }, { rejectWithValue }) => {
    try {
      const response = await api.delete(`ftb/calculation/delete/${fieldId}`, {
        data: { variableIds },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Add option in the dropdown.
export const addOptions = createAsyncThunk(
  "bmr/addOptions",
  async ({ fieldId, data }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/ftb/options/add/${fieldId}`, data);
      notify.success(response.data.message)
      return response.data;
    } catch (error) {
      notify.error(error || error?.message || error?.data?.message)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//@info handle for the delete option.
export const deleteOption = createAsyncThunk(
  "bmr/deleteOption",
  async (optionId, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/ftb/options/delete/${optionId}`);
      notify.success(response.data.message)
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//@info handle update option.
export const updateOptions = createAsyncThunk(
  "bmr/updateOptions",
  async ({ fieldId, data }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/ftb/options/update/${fieldId}`, data);
      notify.success(response.data.message)

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


// @info get options
export const getOptions = createAsyncThunk(
  "bmr/getOptions",
  async ({ fieldId }, { rejectWithValue }) => {
    if (!fieldId) {
      return rejectWithValue("fieldId is required");
    }
    try {
      const response = await api.get(`/ftb/options/${fieldId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Adding here PropertyTab
export const getValidationOptions = createAsyncThunk(
  "bmr/getValidationOptions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/ftb/templates/sections/fields/validations`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Add conditions in radio and dropdown
export const addConditions = createAsyncThunk(
  "bmr/addConditions",
  async ({ fieldId, data }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/ftb/conditions/${fieldId}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// fetch conditions in radio and dropdown
export const getConditions = createAsyncThunk(
  "bmr/getConditions",
  async ({ fieldId }, { rejectWithValue }) => {
    if (!fieldId) {
      return rejectWithValue("fieldId is required");
    }
    try {
      const response = await api.get(`/ftb/conditions/${fieldId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// delete conditions in radio and dropdown
export const deleteConditions = createAsyncThunk(
  "bmr/deleteConditions",
  async ({ fieldId, condition_ids }, { rejectWithValue }) => {
    try {
      const response = await api.delete(`ftb/conditions/${fieldId}`, {
        data: { condition_ids },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Update conditions
export const updateConditions = createAsyncThunk(
  "bmrFbProperty/updateConditions",
  async ({ fieldId, data }, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        `ftb/conditions/${fieldId}`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// Add conditions in radio and dropdown
export const addManualConditions = createAsyncThunk(
  "bmr/addManualConditions",
  async ({ fieldId, data }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/ftb/master-conditions/${fieldId}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


// fetch conditions in radio and dropdown
export const getManualConditions = createAsyncThunk(
  "bmr/getManualConditions",
  async ({ fieldId }, { rejectWithValue }) => {
    if (!fieldId) {
      return rejectWithValue("fieldId is required");
    }
    try {
      const response = await api.get(`/ftb/master-conditions/${fieldId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const deleteManualConditions = createAsyncThunk(
  "bmr/deleteManualConditions",
  async ({ fieldId, condition_uuids }, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `/ftb/master-conditions/${fieldId}`,
        {
          data: { condition_uuids }, // ✅ correct key
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
const bmrFbPropertySlice = createSlice({
  name: "bmrFbProperty",
  initialState,
  reducers: {
    clearLinkedField: (state) => {
      state.linkedField = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInputTypes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchInputTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.inputTypes = action.payload.data;
      })
      .addCase(fetchInputTypes.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(addOptions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addOptions.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addOptions.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(updateOptions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateOptions.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateOptions.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(deleteOption.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteOption.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteOption.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getOptions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOptions.fulfilled, (state, action) => {
        if (action.payload.data) {
          const { field_uuid, field_id, options } = action.payload.data;

          state.options = {
            ...state.options,
            [field_uuid]: { field_id, options },
          };
        } else {
          state.options = {};
        }

        state.isLoading = false;
      })
      .addCase(getOptions.rejected, (state) => {
        state.isLoading = false;
        state.options = {};
      })
      // @info validation part start here
      .addCase(getValidationOptions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getValidationOptions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.validationOptions = action.payload;
      })
      .addCase(getValidationOptions.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getFormulaVariables.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFormulaVariables.fulfilled, (state, action) => {
        if (action.payload.data?.variables) {
          state.formulaVariables = action.payload.data.variables;
        } else {
          state.formulaVariables = [];
        }
        state.isLoading = false;
      })
      .addCase(getFormulaVariables.rejected, (state) => {
        state.isLoading = false;
        state.formulaVariables = [];
      })
      .addCase(addFormulaVariables.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addFormulaVariables.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addFormulaVariables.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteFormulaVariables.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteFormulaVariables.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteFormulaVariables.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getConditions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getConditions.fulfilled, (state, action) => {
        if (action.payload.data?.conditions) {
          const conData = action.payload.data.conditions.map((item) => {
            return {
              ...item,
              option_uuid: item.fbt_option_uuid,
            };
          });
          state.conditions = conData;
        } else {
          state.conditions = [];
        }
        state.isLoading = false;
      })
      .addCase(getConditions.rejected, (state) => {
        state.isLoading = false;
        state.conditions = []; //@info added for the condtions not found.
      })
      .addCase(addConditions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addConditions.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addConditions.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteConditions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteConditions.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteConditions.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(updateConditions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateConditions.fulfilled, (state, action) => {
        state.loading = false;
        state.conditions = action.payload?.data ?? state.conditions;
      })
      .addCase(updateConditions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to update conditions";
      })
      .addCase(getLinkedField.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLinkedField.fulfilled, (state, action) => {
        if (action.payload.data) {
          state.linkedField = action.payload.data;
        } else {
          state.linkedField = null;
        }
        state.isLoading = false;
      })
      .addCase(getLinkedField.rejected, (state) => {
        state.isLoading = false;
        state.linkedField = null;
      })
      .addCase(addLinkedField.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addLinkedField.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addLinkedField.rejected, (state) => {
        state.isLoading = false;
      })

      //@info handler of dependency form
      .addCase(addDependencyField.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addDependencyField.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addDependencyField.rejected, (state) => {
        state.isLoading = false;
      })

      //@info handler for the get added dependency fields
      .addCase(getAddDependencyField.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAddDependencyField.fulfilled, (state, action) => {
        if (action.payload.data) {
          state.getDependentField = action.payload.data;
        } else {
          state.getDependentField = null;
        }
        state.isLoading = false;
      })
      .addCase(getAddDependencyField.rejected, (state) => {
        state.isLoading = false;
        state.getDependentField = null;
      })

      //@info handle the delete dependency with the updated route and config
      .addCase(deleteDependency.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteDependency.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteDependency.rejected, (state) => {
        state.isLoading = false;
      })

      //@info adding for the slice of the manual condition
      .addCase(addManualConditions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addManualConditions.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addManualConditions.rejected, (state) => {
        state.isLoading = false;
      })

      //@info hanling get manual conditions
      .addCase(getManualConditions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getManualConditions.fulfilled, (state, action) => {
        if (action.payload.data?.option_conditions) {
          // ✅ API returns option_uuid directly (not fbt_option_uuid like regular conditions)
          state.manualConditions = action.payload.data.option_conditions;
        } else {
          state.manualConditions = [];
        }
        state.isLoading = false;
      })
      .addCase(getManualConditions.rejected, (state) => {
        state.isLoading = false;
        state.manualConditions = [];
      })

      //@info handling for the delete manual condition
      .addCase(deleteManualConditions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteManualConditions.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteManualConditions.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { clearLinkedField } = bmrFbPropertySlice.actions;
export default bmrFbPropertySlice.reducer;
